import {SaveSubscriptionType, SubscriptionDataType} from './types';

export const subscriptionConsentData: Record<SaveSubscriptionType, SubscriptionDataType> = {
    cl_subscription: {
        eventAction: 'CL',
        label: 'Regular Subscription',
        text: 'By continuing, you understand that your subscription will automatically continue unless cancelled and you authorize GlassesUSA.com to charge your credit card on a recurring basis according to the delivery frequency and for the amount you selected. You can cancel any time to avoid future shipments and charges before the end of the then current billing period via My Account or by calling 1-844-244-1186.',
        type: 'cl_subscription',
    },
    glasses_care_plus: {
        eventAction: 'GlassesCare',
        label: 'GlassesCare+ Subscription',
        text: 'By continuing, you understand that your GlassesCare+ subscription will automatically continue unless cancelled and you authorize GlassesUSA.com to charge your credit card on a recurring basis according to the selected coverage plan. You can cancel any time to avoid coverage plan renewal before the end of the current billing period via My Account or by calling 1-844-244-1186.',
        type: 'glasses_care_plus',
    },
    vista_plus: {
        eventAction: 'CL',
        label: 'Vista Plus',
        text: 'By continuing, you understand that you will be charged $9 today for the 10-day trial period. After the trial ends, your subscription will automatically continue with shipments every 3 months at $22 per shipment unless canceled. You authorize GlassesUSA.com to charge your credit card on this recurring basis. You can cancel any time to avoid future shipments and charges before the end of the then current billing period via My Account or by calling 1-844-244-1186.',
        type: 'vista_plus',
    },
};
